/**
 * Wraps content in modal classes
 */

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal',
  template: `
<div class="modal"
    cdkTrapFocus>

   <div class="modal__body modal__body">
     <button mat-icon-button
             tabindex="-1"
             [mat-dialog-close]="defaultCloseData || null"
             data-test-id="closeModalButton"
             class="modal__close">

       <mat-icon fontSet="fal"
                 fontIcon="fa-times"></mat-icon>
     </button>
     <ng-content></ng-content>
   </div>

</div>
    `
})
export class BaseModalComponent {
  @Input() defaultCloseData: any;
}
